/*

	Module - Modal

	Easily create Modal

	Usage
*/

;(function($, Jasper, window, document, undefined) {
	
	if ( Jasper && Jasper.Modal ) return null;


	$(function() {

		var init = function() {
			//general use
			$('.page-content,#signup_form').on('click','.jasperModal', function(e) {
                e.preventDefault();

                var $btn = $(this);
                
                var callback = {
                    onLoaded : function(){
						var $modal = $(this);
						
                        $('.jasperModal', this).on('click', function(e){
                            e.preventDefault();
                            var modal = new Jasper.Modal(this);
                        });
                        
                        var autosize = new Jasper.Forms.TextAreaAutoSize($('textarea.autosize', this));
						
						if ($('.popovers', this).length){
							$('.popovers', this).popover();
						} 
                        
                        if ($('form.validate', $modal).length) {
                            
                            $('form.validate', $modal).each(function(){
                                var form = new Jasper.Forms.ValidationForm($(this));    
                            });
                        }
                        
                    },

                    onLoad : function() {
                        
                        if ( $btn.attr('href').match(/^job_detail[.]php/i) ) {
                            $(this).find('.modal-body').css('padding',0);
                        }
                    }
                };
                
                var modal = new Jasper.Modal(this, callback);
			});
		}();
	});


	/*

		Modal

	*/

	Jasper.Modal = function(obj, callback) {
		//default settings
		
		
		var btn, btnData = {};
		
		//if link/btn
		if((typeof $(obj).attr('href')) !== 'undefined') { 
			 btn = $(obj);
			 btnData = btn.data();
			 
			 console.log('btn');
		} else { console.log('obj'); }
        
		var o = $.extend({
                ajax:			false,
				href: 			null,
				modalSize:   	'modal-md',
                modalTitle:     false,
				modalContent:   null
			}, obj, btnData);
			
			if((typeof $(obj).attr('href')) !== 'undefined') { 
				o.ajax = btn.attr('href').indexOf('#') >- 1 ? false : true;
				o.href = btn.attr('href');
			}
            
            o.size = o.modalSize;
            o.title = o.modalTitle;
            o.content = o.modalContent;


		var x = $.extend({
				onClosed: 		function(){},
				onLoad: 		function(){},
				onLoaded: 		function(){}
			}, callback);

		/*
			Modal template
			1. need to update/improve base template in the future:
			header, body, footer
		*/
		var Modal = {
			base		: '<div class="modal fade" id="Modal" role="Modal" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"></div></div></div>',
            header		: '<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button><h4 class="modal-title">&nbsp;</h4></div>',
			body		: '<div class="modal-body"><p class="text-center" style="line-height:150px; font-size:40px;"><i class="fa fa-spinner fa-spin"></i></p></div>',
			footer		: '',
			spinner		: '<p class="text-center" style="line-height:150px; font-size:40px;"><i class="fa fa-spinner fa-spin"></i></p>'
		};


		//create bootstrap modal wrapper
		//if ($('.modal').length  === 0 ){
			$(Modal.base).appendTo('body');
		//}
        Modal.id = 'Modal-'+ $('.modal').length;
        
        
        $('#Modal').attr('id', Modal.id);
		var $modal = $('#' + Modal.id);


		//unbind previous binding
		$modal.unbind();


		//populate bootstrap modal template
		o.content = o.content ? '<div class="modal-body">' + o.content + '</div>' : (o.ajax ? (Modal.header + Modal.body) : $(o.hash).html());
		if (o.title && $(o.content).find(".modal-title").length === 0) {
			o.content = Modal.header + o.content;
		}

		$modal.find(".modal-dialog").addClass(o.size);
		$modal.find(".modal-content").html(o.content);
		$modal.find(".modal-title").html(o.title);


		if (o.ajax) {
			$modal.find(".modal-body").load(o.href, function( response, status, xhr ) {
				if ( status == "error" ) {
					var msg = "Sorry but there was an error: ";
					$modal.find(".modal-body").html('<p class="align-center">' +  msg + xhr.status + " " + xhr.statusText + '<p>');
				}
				if (typeof(x.onAjax) === 'function') x.onAjax($modal);

                // initialize responsive tables
                var responsiveTable = new Jasper.Tables.Responsive($modal.find('.jasperDataTableResponsive'));
			});
		}

		$modal.on("show.bs.modal", function(e) {
			x.onLoad.call(this, $modal);
		});

		$modal.on("shown.bs.modal", function(e) {
			x.onLoaded.call(this);
		});

		$modal.on("hidden.bs.modal", function(e) {
			x.onClosed.call(this);
			$modal.find(".modal-dialog").removeAttr("class").addClass("modal-dialog");
			$modal.find(".modal-content").html('');
            $modal.remove();
		});

		//run bootstrap modal
		$modal.modal('show');

	};


})(jQuery, window.Jasper = window.Jasper || {}, window, document);
